<template>
  <div class="p-4 pb-1 w-100 row">
    <icon-view
      class="col-12 icon"
      icon="far fa-times-circle"
      icon-color="#ff7058"
      icon-size="17px"
      title="Cancelar Cuestionario"
    />
    <div class="col-12">
      <validation-observer ref="cancelFormValidator" class="col-12">
        <validation-provider
          v-slot="{ errors }"
          class="row d-flex align-items-end pl-3"
          name="Comment"
          rules="required"
        >
          <custom-input
            v-model="comment"
            class="m-0 mb-1 p-0 col-sm-12 col-md-11"
            custom-error-msg="La razón de cancelación es requerida."
            :error="errors[0]"
            label="Comentario:"
            maxlength="3000"
          />
          <div class="col-sm-12 col-md-1 mb-1 mt-md-4 pt-md-2 align-self-start">
            <action-button
              class="btn-actions mx-1"
              i="fas fa-times-circle"
              variant="outline-danger"
              @click="cancel"
            />
            <action-button
              class="mx-auto btn-actions mx-1"
              i="fas fa-save"
              variant="success"
              @click="save"
            />
          </div>
        </validation-provider>
      </validation-observer>
    </div>
  </div>
</template>

<script>
import IconView from 'icon-view';
import CustomInput from 'CustomInput';
import ActionButton from '@/components/common/ActionButton.vue';
import alertMixin from '@/mixins/alert.mixin';

export default {
  name: 'QuestionnaireCancellation',
  components: {
    IconView,
    CustomInput,
    ActionButton,
  },
  mixins: [alertMixin],
  data() {
    return {
      comment: '',
    };
  },
  methods: {
    async cancel() {
      this.$emit('on-cancel');
    },
    async save() {
      const isValid = await this.$refs.cancelFormValidator.validate();

      if (!isValid) {
        this.ShowToast('Error', 'Información incompleta. (190803)', 'error');
        return;
      }

      this.$emit('on-save', this.comment);
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep .btn-actions {
  i {
    padding-right: 0 !important;
  }
}
.icon ::v-deep {
  .dot {
    em {
      margin-top: 0 !important;
      margin-left: 0 !important;
    }
  }
}
</style>
